import React from 'react'
import PropTypes from 'prop-types';

const TableHead = ({ colLeft, colRight }) => {
  return (
    <thead>
      <tr>
        <th>{colLeft}</th>
        <th>{colRight}</th>
      </tr>
    </thead>
  )
}

TableHead.propTypes = {
  colLeft: PropTypes.string,
  colRight: PropTypes.string
}

export default TableHead
